var extToMimes = {
    'img': 'image/jpeg',
    'png': 'image/png',
    'csv': 'text/csv',
    'gif': 'image/gif',
    'jpeg': 'image/jpeg',
    'pdf': 'application/pdf',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'xls': 'application/vnd.ms-excel',
    'zip': 'application/zip',
    'mp4': 'video/mp4',
    'mp3': 'audio/mpeg',
    'mpg': 'video/mpeg',
    'mpeg': 'video/mpeg',
    'avi': 'video/x-msvideo',
    'mov': 'video/quicktime',
    'wmv': 'video/x-ms-wmv',
 }

export function getMimeTypeByExtension(extension) {
  
    if (extToMimes[extension]) {
        return extToMimes[extension];
    }
}
  
  